module.exports = __webpack_public_path__ + "img/money.6318d764.svg";